module.exports = __webpack_public_path__ + "static/media/bam.e1546c0c.png";